import { BacksolveSourceRow } from 'api/models/BacksolveSourceRow';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { BacksolveApproachAttributes } from 'pages/ValuationsAllocation/types';
import { createColumns } from './createColumns';
import { customParser } from './customParser';
import { SourceTableData } from './customParser/types';
import { customReverseParser } from './customReverseParser';
import { customRowConfig } from './customRowConfig';
import customValidations from './customValidations';
import getVisibleSourceRows from './getVisibleSourceRows';

type CreateBacksolveSourceTableConfigurationParams = {
  rows: BacksolveSourceRow[];
  isDisabled: boolean;
  name: string;
  tableTitle: string;
  companyOverviewUrl?: string;
  fieldAttributes?: BacksolveApproachAttributes;
};

// Alias with explicit object generics so we can use it for property access types.
// SpreadsheetConfig is generic over the initial object, column, table data, and cell data.
type BacksolveSourceTableSpreadsheetConfig = SpreadsheetConfig<object, object, object>;

const createBacksolveSourceTableConfiguration = ({
  rows,
  isDisabled,
  name,
  tableTitle,
  companyOverviewUrl,
  fieldAttributes = {},
}: CreateBacksolveSourceTableConfigurationParams) => {
  const visibleRows = getVisibleSourceRows(rows, isDisabled);
  const rowConfig = customRowConfig({ rows: visibleRows, isDisabled });
  const columns = createColumns({ rows: visibleRows });
  const tableData: SourceTableData = {
    sourceRows: visibleRows,
    isDisabled,
    tableTitle,
    companyOverviewUrl,
    fieldAttributes,
  };

  return new SpreadsheetConfig({
    name,
    columns,
    rowConfig: rowConfig as unknown as BacksolveSourceTableSpreadsheetConfig['rowConfig'],
    tableData,
    parser: customParser as unknown as BacksolveSourceTableSpreadsheetConfig['parser'],
    reverseParser: customReverseParser as unknown as BacksolveSourceTableSpreadsheetConfig['reverseParser'],
    customValidations: customValidations as unknown as BacksolveSourceTableSpreadsheetConfig['customValidations'],
    fieldAttributes,
    showTitlesColumn: false,
    showToolbar: true,
    currencyFormatter: false,
    unitsFormatter: false,
    format: undefined,
    totalParser: undefined,
    ignoreCellExpressionErrors: false,
  } as unknown as ConstructorParameters<typeof SpreadsheetConfig<object, object, object, object>>[0]);
};

export default createBacksolveSourceTableConfiguration;
